import React from "react";

import {
  formatDateTime,
  getSinglarOrPluralWord,
  getTimezoneDate,
  timezones,
} from "../../../../utilities/helpers";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import { DetailsButton } from "../../../DetailsButton";
import { FlexPackNumVouchersBadge } from "../../../FlexPackNumVouchersBadge";

import "./flexPack.scss";

export default function FlexPack({ flexPack, handleShow, handleOpen }) {
  const timezone = timezones(flexPack?.venue?.timezone);

  return (
    <Card body as="li" className="flex-pack-card item card-xs card--light">
      <Stack
        gap={2}
        className="flex-md-row gap-md-3 justify-content-md-between"
      >
        <Stack
          direction="horizontal"
          gap={3}
          className="image-event-info-wrapper"
        >
          <Card.Img
            src={flexPack?.image?.url}
            alt={`Cover art for ${flexPack?.name} flex pack`}
            width="100"
            height="100"
            className="event-image"
          />
          <div className="event-info">
            <div className="event-name-date-wrapper">
              <p className="event-name m-0">{flexPack?.name}</p>
              <p className="small">
                {flexPack?.organization?.name} - {flexPack?.season?.name}
              </p>
            </div>
            <div className="tablet-desktop-only">
              <span className="event-date">
                <span>
                  {formatDateTime(
                    getTimezoneDate(flexPack.start, timezone),
                    "dateOnly",
                  )}
                </span>
                <span className="to">
                  <span>
                    {formatDateTime(
                      getTimezoneDate(flexPack?.end, timezone),
                      "dateOnly",
                    )}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </Stack>
        <div className="mobile-only">
          <span className="event-date">
            <span>
              {formatDateTime(
                getTimezoneDate(flexPack.start, timezone),
                "dateOnly",
              )}
            </span>
            <span className="to">
              <span>
                {formatDateTime(
                  getTimezoneDate(flexPack?.end, timezone),
                  "dateOnly",
                )}
              </span>
            </span>
          </span>
        </div>
        <div className="btn-flex-group">
          {flexPack?.description && (
            <DetailsButton onClick={(e) => handleOpen(flexPack?.description)} />
          )}
          <FlexPackNumVouchersBadge tickets={flexPack?.vouchers?.length} />
          <Button className="mt-0" onClick={(e) => handleShow(flexPack)}>
            View{" "}
            {getSinglarOrPluralWord(
              flexPack?.vouchers?.length,
              "voucher",
            ).toLowerCase()}
          </Button>
        </div>
      </Stack>
    </Card>
  );
}
